<template>
  <div>
    <vs-row vs-justify="space-between" class="mb-4">
      <vs-col vs-w="6">
        <h3 class="mr-4">Segmentation tester</h3>
        <p class="mt-5">Here you can test how many guests fullfill the entered segmentation criteria</p>
      </vs-col>
    </vs-row>

    <guest-query-builder :guestQuery.sync="guestQuery" :canRemoveConsent="true" />

    <div style="height: 400px"></div>
  </div>
</template>

<script>
import moment from "moment";

import GuestQueryBuilder from "@/components/GuestQueryBuilder.vue";

export default {
  components: {
    GuestQueryBuilder
  },
  data() {
    return {
      moment,

      queryResult: -1,

      guestQuery: {
        hasVenues: false,
        hasAge: false,
        hasLabels: false,
        hasInterest: false,
        hasConsents: false,
        hasFixrEvent: false,

        minAge: 18,
        maxAge: 40,
        labels: [],
        interestKey: null,
        interestValue: "",
        consentVenues: [],
        consentTypes: [], // Old
        consentPermissions: [],
        fixrEventFilter: ""
        // fixrEventNumTickets: 0,
        // fixrEventNumTicketsOperator: 0
      }
    };
  }
};
</script>

<style lang="scss" scoped>
.color-box {
  width: 40px;
  height: 40px;
  border-radius: 12px;
  background-color: rgba(var(--vs-primary)) !important;
  box-shadow: 0px 15px 40px -10px rgba(var(--vs-primary), 0.9);

  display: flex;
  align-items: center;
  justify-content: center;

  color: white;

  opacity: 1;
  transition: opacity 0.15s;

  &.hide {
    opacity: 0;
    pointer-events: none;
  }
}
</style>